module.exports = __webpack_public_path__ + "media/src/application/media/v2-icon-2-823808acc4a790b0509e0e3c973357b9.svg";